import { AgencyRequestsManager } from '@/components/brand/AgencyRequestsManager';
import PageHeader from '@/components/common/PageHeader';
import { useBrandAuth } from '@/hooks/useBrandAuth';

export function AgencyRequests() {
  const { user } = useBrandAuth();

  return (
    <div className="flex-1 space-y-6">
      <PageHeader
        title="Partner Requests"
        description="Review and respond to requests from partners"
        username={user?.companyName || ""}
        showDefaultActions={false}
      />
      
      <AgencyRequestsManager />
    </div>
  );
}
